<div class="app-settings-page">
  <h2>App Settings</h2>

  <div class="card">
    <div class="card-header">
      <h2>Timeout Parameters</h2>
      <p class="sub">Session timeout controls for the UI</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSaveTimeoutSettings()">
      <div class="grid">
        <label class="field">
          <span class="label">Timeout</span>
          <div class="input-row">
            <input class="input-sm" type="number" formControlName="uiTimeoutMinutes" min="1" step="1">
            <span class="unit">minutes</span>
          </div>
          <small class="hint">{{ uiTimeoutMs | number }} ms</small>
        </label>

        <label class="field">
          <span class="label">Timeout Warning</span>
          <div class="input-row">
            <input class="input-sm" type="number" formControlName="uiWarningMinutes" min="1" step="1">
            <span class="unit">minutes</span>
          </div>
          <small class="hint">{{ uiWarningMs | number }} ms</small>

        </label>
        <small class="error" *ngIf="form.hasError('range') && (form.dirty || form.touched)">
          Warning must be less than Timeout.
        </small>
      </div>

      <div class="actions">
        <button type="submit" [disabled]="form.invalid || saving">Save</button>
        <span *ngIf="saved" class="ok">Saved</span>
      </div>
    </form>
  </div>

  <div class="card">
    <div class="card-header">
      <h2>Backfill Missing CCOs</h2>
      <p class="sub">
        This action will search all referrals with missing CCOs, look up CCOs, and update those referrals.
        <strong>This cannot be undone.</strong>
      </p>
    </div>

    <form (ngSubmit)="backfillMissingCCOs()" class="backfill-form">
      <div class="actions">
        <label class="safety-check">
          <input type="checkbox" [(ngModel)]="confirmBackfill" name="confirmBackfill">
          <span>I understand and want to proceed with the backfill</span>
        </label>

        <button type="submit"
                [disabled]="!confirmBackfill || backfilling"
                [class.danger]="confirmBackfill">
          {{ backfilling ? 'Backfilling…' : 'Backfill' }}
        </button>
      </div>
    </form>
  </div>
</div>
